<form nz-form style="padding-top:24px;padding-right:24px">
  <div nz-row nzGutter="24">
    <div nz-col nzSm="24" nzMd="24" nzLg="4" nzXl="3" style="text-align: center;">
      <nz-form-item>
        <nz-upload
          class="avatar-uploader"
          nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          nzName="avatar"
          nzListType="picture-card"
          [nzShowUploadList]="false"
          [nzBeforeUpload]="beforeUpload"
          (nzChange)="handleChange($event)"
        >
        <ng-container *ngIf="!avatarUrl">
          <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
          <div class="ant-upload-text">Upload</div>
        </ng-container>
        <img *ngIf="avatarUrl" [src]="avatarUrl" style="width: 100%" />
        </nz-upload>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24" nzLg="20" nzXl="21">
      <div nz-row nzGutter="24">
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="maHS">Mã học sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <div nz-row nzGutter="24">
                <div nz-col nzSpan="8">
                    <input nz-input name="email" type="email" id="email" [jAutofocus]>
                </div>
                <div nz-col nzSpan="8">
                    <input nz-input name="email" type="email" id="email">              
                </div>
                <div nz-col nzSpan="8">
                    <input nz-input name="email" type="email" id="email">           
                </div>
              </div>
          </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Trường</nz-form-label>
            <nz-form-control nzSpan="24">            
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Họ đệm</nz-form-label>
            <nz-form-control nzSpan="24">
              <div nz-row nzGutter="24">
                <div nz-col nzSpan="16">
                  <input nz-input name="email" type="email" id="email">
                </div>
                <div nz-col nzSpan="8">
                  <input nz-input name="email" type="email" id="email">
                </div>
              </div>
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Năm nhập học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-date-picker nzMode="year" (ngModelChange)="onChange($event)"></nz-date-picker>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="14">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Ngày tiếp nhận</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-range-picker (ngModelChange)="onChange($event)"></nz-range-picker>
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Tên gọi khác</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input name="email" type="email" id="email">
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Khối lớp</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Tên lớp học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Thứ tự</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Giới Tính</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-checkbox-group>
                <label nz-checkbox nzValue="tatCa">Tất cả</label>
                <label nz-checkbox nzValue="nam">Nam</label>
                <label nz-checkbox nzValue="nu">Nữ</label>
              </nz-checkbox-group>
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Trạng thái học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="14">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">N.nhân thôi học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Nơi sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input name="email" type="email" id="email">
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Hs học bạ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="14">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Mã ESAMS</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Ngày sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-date-picker [nzFormat]="'dd/MM/yyyy'" (ngModelChange)="onChange($event)"></nz-date-picker>
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Quốc tịch</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="14">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Dân tộc</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
        <div nz-col nzSm="24" nzMd="8">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="email">Ghi chú</nz-form-label>
            <nz-form-control nzSpan="24">
              <textarea nz-input nzAutosize></textarea>
            </nz-form-control>
          </nz-form-item >
        </div>
        <div nz-col nzSm="24" nzMd="16">
          <div nz-row nzGutter="24">
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Tôn giáo</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="14">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">D.tộc trên GKS</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div nz-row nzGutter="24">
    <div nz-col nzSpan="24">
      <nz-tabset nzType="card">
        <nz-tab [nzTitle]="'I.Thông tin liên lạc'">
          <div nz-row nzGutter="24" style="padding: 10px;">
            <nz-divider nzText="Thông tin liên lạc" nzOrientation="left" nzPlain ></nz-divider>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">ĐT liên hệ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Email</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Tỉnh thành</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Quận huyện</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Phường xã</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Hộ khẩu</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Chỗ ở hiện nay</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Thôn xóm</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
        </nz-tab>
        <nz-tab [nzTitle]="'II.Thông tin cá nhân'">
          <div nz-row nzGutter="24" style="padding: 10px;">
            <nz-divider nzText="Thông tin cá nhân" nzOrientation="left" nzPlain ></nz-divider>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Khu vực</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Khuyết tật</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Diện chính sách</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Học bán trú</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Số buổi học/tuần</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Bệnh về mắt</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả">
                    <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
                    <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
                    <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
                    <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
                    <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
                    <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item >
            </div>
          </div>
          <nz-divider></nz-divider>
          <div nz-row nzGutter="24" style="padding: 10px;">
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Là hội viên</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Lưu ban năm trước</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Tư vấn GH H.nghiệp</label></nz-form-item></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Hỗ trợ nhà ở</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Hỗ trợ ăn trưa</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Hỗ trợ chi phí học tập</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Cấp tiền hàng tháng</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Cấp gạo</label></nz-form-item></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Thuộc vùng khó khăn</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Thuộc hộ nghèo</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Miễn học phí</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Giảm học phí</label></nz-form-item></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học sinh bán trú dân nuôi</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học sinh nội trú dân nuôi</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học sinh D.tộc hỗ trợ giảng</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>HS P.thông D.tộc bán trú</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học sinh học tiếng dân tộc</label></nz-form-item></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học song ngữ</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học kỹ năng sống</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học C.trình G.dục của bộ</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học mẫu giáo 5 tuổi</label></nz-form-item></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Nhu cầu hỗ trợ ngoại ngữ</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Tăng cường tiếng Việt</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Khuyết tật không đánh giá</label></nz-form-item></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="2"></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>Học sinh biết bơi</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>P.huynh có Smartphone</label></nz-form-item></div>
            <div nz-col nzSpan="4"><nz-form-item><label nz-checkbox>P.huynh có M.tính K.nối Internet</label></nz-form-item></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="4"></div>
            <div nz-col nzSpan="2"></div>
          </div>
        </nz-tab>
        <nz-tab [nzTitle]="'III.Thông tin gia đình'">
          <div nz-row nzGutter="24" style="padding: 10px;">
            <nz-divider nzText="Thông tin phụ huynh" nzOrientation="left" nzPlain></nz-divider>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Họ tên cha</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Thông tin cha</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Số CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item><label nz-checkbox>Cha là người dân tộc</label></nz-form-item>
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Điện thoại</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Nghề nghiệp mẹ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Email</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Địa chỉ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <nz-divider></nz-divider>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Họ tên mẹ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Thông tin mẹ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Số CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item><label nz-checkbox>Mẹ là người dân tộc</label></nz-form-item>
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Điện thoại</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Nghề nghiệp mẹ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Email</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Địa chỉ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <nz-divider nzText="Thông tin người đỡ đầu" nzOrientation="left" nzPlain ></nz-divider>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Họ tên NĐĐ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Thông tin NĐĐ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Số CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item><label nz-checkbox>NĐĐ là người dân tộc</label></nz-form-item>
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Điện thoại</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div> 
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Nghề nghiệp NĐĐ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Email</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="email">Địa chỉ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item >
            </div>
          </div> 
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close($event)">Đóng</button>
    <button nz-button nzType="primary">Thêm</button>
  </div>
</form>